import type z from "zod";
import { type ApiOptions, api } from "../api/apiClient";
import { appConfig } from "../appConfig";
import { getCsrfToken } from "./trustAuthAPI";

const TRUST_OPTIONS = {
  excludeToken: true,
  excludeCurrentOrganisationId: true,
  credentials: "include",
} satisfies Partial<ApiOptions>;
const BASE_ENDPOINT = `${appConfig.env.API_URL}/novatrust/v1`;
const CSRF_TOKEN_HEADER_KEY = "X-XSRF-TOKEN";

const withCsrf =
  (send: typeof api.post) =>
  async <Schema extends z.ZodTypeAny>(endpoint: string, payload: unknown, options?: ApiOptions<Schema>) => {
    const csrfToken = await getCsrfToken();
    return send(`${BASE_ENDPOINT}/${endpoint}`, payload, {
      ...options,
      ...TRUST_OPTIONS,
      headers: { ...options?.headers, [CSRF_TOKEN_HEADER_KEY]: csrfToken },
    });
  };

export const trustAPI = {
  get: <Schema extends z.ZodTypeAny>(endpoint: string, options?: ApiOptions<Schema>) =>
    api.get(`${BASE_ENDPOINT}/${endpoint}`, { ...options, ...TRUST_OPTIONS }),
  post: withCsrf(api.post),
  patch: withCsrf(api.patch),
};
